<template>
    <button class="main-button"> {{ textBtn }} </button>
</template>
<script>

export default {
    props: {
        textBtn: { type: String, require: '' }
    }
}
</script>
<style lang="scss" scoped>
.main-button {
    background-color: #CCCCCC;
    border: none;
    color: #999999;
    text-align: center;
    font-size: 1.125rem;
    font-weight: 700;
    width: 100%;
    height: 45px;
    border-radius: 10px;
}
</style>